export default (queryString = '') => {
  if (queryString[0] && queryString[0] === '?') {
    queryString = queryString.substring(1);
  }

  const query = queryString.split('&');
  const parameters = {};

  for (let i = 0; i < query.length; i++) {
    const parts = query[i].split('=', 2);
    parameters[parts[0]] = parts[1] ? parts[1] : undefined;
  }

  return parameters;
};
